import { Link } from "react-router-dom";
import { TESTIDS } from "@/constants/testIds";

export function SiteFooter() {
  return (
    <footer
      data-testid={TESTIDS.siteFooter}
      className="mt-20 border-t border-border/60 bg-card/40"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <p className="font-display text-lg font-semibold">Play Tsoro</p>
          <p className="mt-2 text-sm text-muted-foreground max-w-sm">
            A digital home for Tsoro and its sister mancala games across the
            African continent. Built with respect for the traditions that
            inspired it.
          </p>
          <p className="mt-4 text-xs text-muted-foreground font-mono">
            playtsoro.com
          </p>
          <p className="mt-1 text-xs text-muted-foreground">
            A Southern African Traders Ltd platform
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold mb-3">Play</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/play" className="hover:text-foreground">Modes</Link></li>
            <li><Link to="/play/standard" className="hover:text-foreground">Zimbabwean Tsoro</Link></li>
            <li><Link to="/practice" className="hover:text-foreground">Practice board</Link></li>
            <li><Link to="/learn" className="hover:text-foreground">Tutorial</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-sm font-semibold mb-3">Library</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/rules" className="hover:text-foreground">Rules</Link></li>
            <li><Link to="/variants" className="hover:text-foreground">Country variants</Link></li>
            <li><Link to="/about" className="hover:text-foreground">About</Link></li>
            <li><Link to="/privacy" className="hover:text-foreground">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-foreground">Terms</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Southern African Traders Ltd. All rights reserved.</p>
          <p>Built with care for African board-game traditions · playtsoro.com</p>
        </div>
      </div>
    </footer>
  );
}
